export default __webpack_public_path__ + "static/media/tshirt2.cc73477e.png";